import { Popover } from "@mui/material";
import { useRef, useState } from "react";
import { ChromePicker, ColorChangeHandler } from "react-color";

export interface ColorPickerProps {
  open: boolean;
  element: HTMLElement;
  initialColor?: string;
  onColor: (color: string) => void;
  onClose?: () => void;
}
export const ColorPicker: React.FC<ColorPickerProps> = ({ open, element, initialColor, onColor, onClose }) => {
  const timerColor = useRef<NodeJS.Timeout>();
  const [color, setColor] = useState(initialColor);

  const handleEditCol: ColorChangeHandler = (color) => {
    setColor(`rgba(${color.rgb.r}, ${color.rgb.g}, ${color.rgb.b}, ${color.rgb.a ?? 1})`);

    if (timerColor.current) clearTimeout(timerColor.current);
    timerColor.current = setTimeout(() => {
      onColor(`rgba(${color.rgb.r}, ${color.rgb.g}, ${color.rgb.b}, ${color.rgb.a ?? 1})`);
    }, 500);
  };

  return <Popover
    open={open}
    anchorEl={element}
    onClose={onClose}
  >
    <ChromePicker
      disableAlpha={false}
      color={color}
      onChange={handleEditCol}
    />
  </Popover>;
};